import { render, staticRenderFns } from "./EdicaoRateioMedico.vue?vue&type=template&id=259af9f0&"
import script from "./EdicaoRateioMedico.vue?vue&type=script&lang=js&"
export * from "./EdicaoRateioMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports